/* eslint-disable no-unused-vars */
export type TNotation = "bps" | "c" | "$" | "%" | "$p" | "$fr";

export type NotationToDecimalValueType =
  | "bps"
  | "c"
  | "$"
  | "%"
  | "$p"
  | "$fr"
  | "strike";

export function isNotationToDecimalValueType(
  value: string,
): value is NotationToDecimalValueType {
  return ["bps", "c", "$", "%", "$p", "$fr", "strike"].includes(value);
}
